import { useEffect } from 'react';

// Mirrors each page's own "section-aware nav background" script: toggles
// #site-nav between its light/dark tone as the user scrolls past named
// sections. `sections` is the same [id, tone][] list every page's original
// inline script hardcoded for itself.
export function useNavTone(sections) {
  useEffect(() => {
    const nav = document.getElementById('site-nav');
    const footer = document.querySelector('.site-footer');
    if (!nav) return undefined;

    function updateNavTone() {
      const checkAt = window.scrollY + 36;
      let tone = null;
      for (const [id, t] of sections) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top + window.scrollY <= checkAt) tone = t;
      }
      if (footer && footer.getBoundingClientRect().top + window.scrollY <= checkAt) tone = 'dark';
      nav.classList.toggle('nav-dark', tone === 'dark');
      nav.classList.toggle('nav-light', tone === 'light');
    }
    window.addEventListener('scroll', updateNavTone, { passive: true });
    updateNavTone();
    return () => window.removeEventListener('scroll', updateNavTone);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sections]);
}
